// @flow

import type {InjectIntlProvidedProps} from 'react-intl';

import React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {ModalAlert, Tooltip} from '@xsolla/uikit';
import classNames from 'classnames/bind';
import {compose} from 'recompose';
import {download, unsetErr} from '../../../../reducers/disputes/actions/report';
import {
  selectReport,
  selectTableFetching,
  selectTableRowsCount
} from '../../../../reducers/disputes/selectors';
import {buildReportTranslations} from '../../../../utils/buildReportTranslations';
import Button from '../../components/button';
import style from './style.css';

type Props = {
  +available: boolean,
  +isError: boolean,
  +fetching: boolean,
  +download: (string, ?Object) => void,
  +unsetErr: () => void
} & InjectIntlProvidedProps;

const cx = classNames.bind(style);
const COUNT_LIMIT = 20000;

const Report = (props: Props) => {
  const {intl, available, isError, fetching, unsetErr, download} = props;

  const handleDownload = () => {
    const language = intl.locale;
    const translations = buildReportTranslations(intl);
    download(language, translations);
  };

  const content = available ? (
    <Button icon="download" disabled={false} fetching={fetching} onClick={handleDownload}>
      {intl.messages['app.support.disputes.actions.download-report']}
    </Button>
  ) : (
    <Tooltip
      className={cx('action-report__tooltip')}
      position="top"
      label={intl.formatMessage(
        {id: 'app.support.disputes.actions.download-report.unavailable-hint'},
        {limit: COUNT_LIMIT}
      )}>
      <Button icon="download" disabled={true}>
        {intl.messages['app.support.disputes.actions.download-report']}
      </Button>
    </Tooltip>
  );

  return (
    <div className={cx('action-report')}>
      <ModalAlert
        isOpen={isError}
        icon={require('../../../../images/icons/alert--red.svg')}
        title={intl.messages['app.support.disputes.actions.download-report.err-modal.title']}
        description={
          intl.messages['app.support.disputes.actions.download-report.err-modal.description']
        }
        discard={intl.messages['app.support.disputes.actions.download-report.err-modal.ok']}
        onClose={unsetErr}
      />
      {content}
    </div>
  );
};

const mapStateToProps = state => ({
  count: selectTableRowsCount(state),
  fetching: selectReport(state).fetching,
  isError: selectReport(state).isError,
  tableFetching: selectTableFetching(state)
});

const mapDispatchToProps = {
  download,
  unsetErr
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  available: !stateProps.tableFetching && stateProps.count !== 0 && stateProps.count <= COUNT_LIMIT,
  fetching: stateProps.fetching,
  isError: stateProps.isError,
  download: dispatchProps.download,
  unsetErr: dispatchProps.unsetErr
});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps, mergeProps), injectIntl);

export default enhance(Report);
